module.exports = __webpack_public_path__ + "img/wave_line.bbbd1cc6.png";